import { useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { TRIAL_DAYS } from "../../../constants/trial";
import { trackTryClick } from "../../../analytics/metrikaGoals";
import PunchMatteImage from "./PunchMatteImage";
import s from "./createAppLanding.module.css";

const STEPS = [
  {
    num: "01",
    title: "Создайте клуб",
    text: `Регистрация, название и логотип. ${TRIAL_DAYS} дней «Максимального» без карты.`,
    src: "/landing/mock-brand-splash.png",
    phoneLeft: true,
  },
  {
    num: "02",
    title: "Настройте расписание",
    text: "Группы, абонементы и цены. Клиентов приглашаете ссылкой или QR.",
    src: "/landing/mock-owner-clients.png",
    phoneLeft: false,
  },
  {
    num: "03",
    title: "Откройте приложение клиентам",
    text: "Они видят занятия, оплачивают и получают уведомления под вашим брендом.",
    src: "/landing/mock-client-home.png",
    phoneLeft: true,
  },
];

/** Smooth path through dot centers, with a gentle bow between each pair. */
function pathThroughDots(pts) {
  if (pts.length < 2) return "";
  const [first, ...rest] = pts;
  let d = `M ${first.x} ${first.y}`;
  let prev = first;
  rest.forEach((pt, i) => {
    const midY = (prev.y + pt.y) / 2;
    const bow = i % 2 === 0 ? -28 : 28;
    d += ` C ${prev.x} ${midY + bow * 0.15}, ${pt.x + bow} ${midY}, ${pt.x} ${pt.y}`;
    prev = pt;
  });
  return d;
}

export default function ScrollSteps() {
  const wrapRef = useRef(null);
  const dotRefs = useRef([]);
  const [path, setPath] = useState("");
  const [box, setBox] = useState({ w: 100, h: 100 });

  useLayoutEffect(() => {
    const wrap = wrapRef.current;
    if (!wrap) return undefined;

    const update = () => {
      const wr = wrap.getBoundingClientRect();
      if (wr.width < 8 || wr.height < 8) return;
      const pts = dotRefs.current
        .filter(Boolean)
        .map((el) => {
          const r = el.getBoundingClientRect();
          return {
            x: r.left + r.width / 2 - wr.left,
            y: r.top + r.height / 2 - wr.top,
          };
        });
      setBox({ w: wr.width, h: wr.height });
      setPath(pathThroughDots(pts));
    };

    update();
    const ro = new ResizeObserver(update);
    ro.observe(wrap);
    window.addEventListener("resize", update);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <section id="steps" className={s.stepsSimple} aria-label="Шаги">
      <div className={s.stepsSimpleHead}>
        <h2 className={s.stepsTitle}>Шаги</h2>
      </div>

      <div className={s.stepsZigWrap} ref={wrapRef}>
        <svg
          className={s.stepsZigPath}
          viewBox={`0 0 ${box.w} ${box.h}`}
          preserveAspectRatio="none"
          aria-hidden
        >
          {path ? (
            <path className={s.stepsZigStroke} d={path} fill="none" />
          ) : null}
        </svg>

        <ol className={s.stepsZigzag}>
          {STEPS.map((step, i) => (
            <li
              key={step.num}
              className={`${s.stepsZigItem} ${
                step.phoneLeft ? s.stepsZigPhoneLeft : s.stepsZigPhoneRight
              }`}
            >
              <div className={s.stepsZigMedia}>
                <PunchMatteImage
                  src={step.src}
                  alt={step.title}
                  className={s.stepsZigPhone}
                />
              </div>

              <div className={s.stepsZigRail}>
                <span
                  className={s.stepsZigDot}
                  ref={(el) => {
                    dotRefs.current[i] = el;
                  }}
                >
                  {step.num}
                </span>
              </div>

              <div className={s.stepsZigCopy}>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>

      <div className={s.stepsSectionCta}>
        <Link
          to="/register-clinic"
          className={`${s.btn} ${s.btnPrimary} ${s.btnLg}`}
          onClick={() => trackTryClick({ landing: "app" })}
        >
          Начать бесплатно — {TRIAL_DAYS} дней
        </Link>
      </div>
    </section>
  );
}
